import React, { useContext } from "react";
import { LinkButtonPrimary } from "@ui/buttons";

const CtaWidget = ({ data }) => {
    const { enableCustomAction, customAction, styleType } = data;
    const { text, url, external, attributes } = data.action;

    const handleClick = enableCustomAction
        ? (e) => {
              e.preventDefault();
          }
        : null;

    const css = `text-center ${styleType === "InPlace" ? "w-fit" : ""}`;

    return (
        <div className="text-center max-w-lg">
            <LinkButtonPrimary
                url={url}
                external={external}
                className={css}
                onClick={handleClick}
                {...attributes}
            >
                {text}
            </LinkButtonPrimary>
        </div>
    );
};

export default CtaWidget;
